import { reducer } from './dataReducer'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import ReceivingData from './receivingData'
import './assets/widget-icon.scss'

const type = 'og_models_well_schematic'

widgetService.register({
    get type() {
        return type
    },
    get name() {
        return 'OG Models Well Schematic'
    },
    get description() {
        return 'Well Schematic that displays info about the casing shoe, drillstring velocity, bit depth and the hole depth. Commonly used on the OG Models dashboards.'
    },
    config: {},
    policies: {
        defaultReducer: '@latest'
    },

    impl: reactWidgetWrapper<ChartStateWellSchematic, ChartMessageWellSchematic, Configs>(ReceivingData, reducer)
})
